import DownloadIcon from 'components/DownloadIcon'
import SpinnerIcon from 'components/SpinnerIcon'

export const iconMap = {
  loading: SpinnerIcon,
  download: DownloadIcon,
}
